import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { commonInfoBoxPadding } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  left: ReactNode;
  right: ReactNode;
}

export function InfoBoxBottomPart(props: Props) {
  return (
    <Root>
      <Child>{props.left}</Child>
      <Child>{props.right}</Child>
    </Root>
  );
}

const Root = styled.div`
  flex-grow: 0;
  border-top: 1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};
  display: flex;
  font-size: 11px;
  ${commonInfoBoxPadding}
  padding-top: 8px;
  padding-bottom: 8px;
  justify-content: space-between;
  align-items: center;
  color: ${BouColor.TOOL_TEXT_DARKER_GRAY};
`;

const Child = styled.div`
  display: flex;
  align-items: center;
  gap: 1em;
`;
